import { forwardRef, Ref, SVGProps } from 'react';
import { Chip as ChipPR, ChipProps } from 'primereact/chip';
import { CloseIcon } from './icons';

export const Chip = forwardRef((props: ChipProps, ref?: Ref<ChipPR>) => {
  return (
    <ChipPR
      ref={ref}
      {...props}
      removeIcon={
        props.removeIcon ||
        ((options) => <CloseIcon {...(options.iconProps as SVGProps<SVGSVGElement>)} key={options?.props?.label} />)
      }
    />
  );
});

export type { ChipProps };
